<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventDiscounts"
        title-table="Descontos de Eventos"
        module="eventDiscountSettingsModule"
        sort-name="descricao"
        :show-btn-add="verificarPermissao('ROLE_CORE_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_CORE_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <EventDiscountForm v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import { verificarPermissao } from "@/auth/utils";
import EventDiscountForm from "./form/EventDiscountForm.vue";

export default {
  name: "EventDiscountSetting",
  components: {
    BRow,
    BCol,
    TableComponents,
    EventDiscountForm,
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "ID",
          field: "id",
          width: "80px",
        },
        {
          label: "Descrição",
          field: "descricao",
        },
        {
          label: "Evento",
          field: "evento.nome",
        },
        {
          label: "Tipo",
          field: "tipo.nome",
        },
        {
          label: "% Desconto",
          field: "percentualDesconto",
          formatter: (value) => (value ? `${value}%` : "-"),
        },
        {
          label: "Valor Desconto",
          field: "valorDesconto",
          formatter: (value) =>
            value
              ? value.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              : "-",
        },
        {
          label: "Status",
          field: "ativo",
          formatter: (value) => (value ? "Ativo" : "Inativo"),
          width: "100px",
        },
      ],
    };
  },
  computed: {
    ...mapState("eventDiscountSettingsModule", {
      listaEventDiscounts: (state) => state.listaEventDiscounts,
    }),
    verificarPermissao() {
      return verificarPermissao;
    },
  },
  methods: {
    addNew() {
      this.$store.dispatch("eventDiscountSettingsModule/reset");
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch("eventDiscountSettingsModule/prepareToEdit", data);
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
      this.$store.dispatch("eventDiscountSettingsModule/reset");
    },
  },
};
</script>
